import gql from "graphql-tag";

export default gql`
  query publicGroupTestPin($groupId: ID!, $pin: Float!) {
        publicGroupTestPin(groupId: $groupId, pin: $pin) {
          message
      }
  }
`;
